<template>
  <!-- <section> -->
  <div class="login-box mx-auto">
    <div class="card">
      <div class="card-body login-card-body">
        <div class="login-logo">
          <img width="40%" height="auto" src="@/assets/login/Logo.png">
        </div>
        <h4>
          <p class="login-box-msg text-bold">{{ $t('words.recovery_password') }}</p>
        </h4>
        <div class="form-group" :class="{'is-invalid':errors.has('email')}">
          <input v-model="auth.email" v-validate="{required:true, email:true}" type="email" class="form-control"
            :placeholder="$t('words.type_email')" name="email" required>
          <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
          <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
        </div>
        <div class="form-group">
          <b class="text-red text-center">{{message}}</b>
        </div>
        <div class="row justify-content-between m-0">        
            <a @click="status.box='login'" href="#"> Lembrei! </a>
            <button type="button" @click="submit" :disabled="loading" class="float-right btn btn-primary">
              <i class="fa fa-check"></i> {{$t('words.send_email')}} <i v-show="loading"
                class="fa fa-circle-o-notch fa-spin"></i>
            </button>
        </div>
      </div>
    </div>
    <!-- /.login-box-body -->
  </div>
  <!-- <div class="col-md-8 text-center">
      <div class="login-img">
        <img src="../../assets/login-image.png">
      </div>
    </div> -->
  <!-- </section> -->
</template>

<script>
  /* eslint-disable no-console */
  /* eslint-disable no-undef */
  export default {
    props: ['status'],
    data() {
      return {
        auth: {
          email: null,
          grecaptcha: null
        },
        loading: false,
        message: '',
      };
    },
    beforeMounted() {
      this.$auth.check().then(response => {
        if (response) {
          this.$router.push({
            name: 'index'
          });
        }
      });
    },
    methods: {
      async submit() {
        this.auth.grecaptcha = await this.$recaptcha("recoveryPassword").then(token => {
          return token;
        });
        this.$validator.validateAll(['email']).then(valid => {
          if (valid) {
            this.loading = true;
            this.$auth
              .recoveryPassword(this.auth)
              .then(response => {
                this.loading = false;
                toastr({
                  icon: 'success',
                  title: response.data.message
                });
                this.auth.email = '';
                this.$validator.reset();
              })
              .catch(error => {
                this.loading = false;
                toastr({
                  icon: 'error',
                  title: error.response.data.message
                });
              });
          } else {
            this.signin_error = this.errors.all()[0];
          }
        });
      },
      markRecaptchaAsVerified(response) {
        this.recaptchaVerified = true;
        this.message = '';
      },
    }
  };
</script>

<style scoped>
  /* body {
    background-image: url("../../assets/body.jpg");
    background-size: 100vw 100vh;
    background-attachment: fixed;
  } */

  .login-box {
    /* width: 100%; */
    margin: 0;
  }

  .login-box-body {
    /* margin-top: -15%; */
    /* background-color: rgba(255, 255, 255, .15); */
    background: #ffffffdd !important;
  }

  .login-box-body .form-control {
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid dimgray;
  }

  .login-box-body input.form-control::placeholder {
    color: dimgray;
  }

  .login-box-body input.form-control:focus {
    outline-width: 0;
  }

  .login-box-body .form-control-feedback {
    left: 0;
  }

  .login-box-body .has-feedback .form-control {
    padding-right: 12px;
    padding-left: 30px;
  }

  /* 
  .login-img {
    margin-top: 5%;
    width: 40vw;
    right: -20%;
    position: relative;
    overflow: hidden;
  } */

  @keyframes pulse {
    from {
      transform: translateX(-50%) skewX(-15deg);
    }

    to {
      transform: translateX(900%) skewX(-15deg);
    }
  }

  @-webkit-keyframes pulse {
    from {
      -webkit-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -webkit-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-moz-keyframes pulse {
    from {
      -moz-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -wemozbkit-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-ms-keyframes pulse {
    from {
      -ms-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -ms-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-o-keyframes pulse {
    from {
      -o-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -o-transform: translateX(400%) skewX(-15deg);
    }
  }
</style>